import { useTranslation } from 'react-i18next';

import { PageHeader } from '@/components/page-header/page-header';
import { Typography } from '@/components/typography/typography';

import { Stack } from '@/lib/shadcn/components/ui/stack/stack';

import { ErrorPageLayout } from './error-page-layout';
import { NotFoundIcon } from './icons/not-found-icon';

export function NotFoundErrorPage() {
  const { t } = useTranslation();
  return (
    <ErrorPageLayout
      withContactUs
      headerComponent={<PageHeader right className="w-full justify-between" />}
    >
      <Stack gap={11} align="center" className="mt-[11vh] flex-1">
        <NotFoundIcon />
        <Stack gap={6} className="text-center">
          <Typography.h3 className="text-teal-500">
            {t('errors.not-found.title')}
          </Typography.h3>
          <Typography.p3 className="text-slate-400">
            {t('errors.not-found.text')}
          </Typography.p3>
        </Stack>
      </Stack>
    </ErrorPageLayout>
  );
}
